
// All the varibles 
export const API_URL="https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC=10;
export const RES_PER_PAGE=10;
export const KEY='20861751-6732-4c93-9ca2-4953e61c5668'